import api from './api';

const ClientService = {
  GetAllClients: () => {
    return api
      .get('/Client/GetAllClient')
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetAllClients:', error);
        throw error;
      });
  },

  GetClientById: (clientId) => {
    if (!clientId) {
      return Promise.reject(new Error("Client ID is required"));
    }

    return api
      .get(`/Client/GetClientById?client_id=${encodeURIComponent(clientId)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetClientById:', error);
        throw error;
      });
  },

  AddClient: (data) => {
    if (!data?.client_name) {
      return Promise.reject(new Error("Client name is required"));
    }

    return api
      .post('/Client/AddClient', null, {
        params: {
          client_name: data.client_name,
          contact_person: data.contact_person || "",
          contact_phone: data.contact_phone || "",
          contact_email: data.contact_email || "",
          address_line1: data.address_line1 || "",
          address_line2: data.address_line2 || "",
          city: data.city || "",
          country: data.country || "",
          business_name: data.business_name || "",
          industry_type: data.industry_type || ""
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - AddClient:', error.response?.data || error.message);
        throw error;
      });
  },

  // Update Client Status (NEW)
  UpdateClientStatus: (clientId, status) => {
    if (!clientId) {
      return Promise.reject(new Error("Client ID is required"));
    }
    
    if (!status || (status !== "A" && status !== "I")) {
      return Promise.reject(new Error("Valid status (A or I) is required"));
    }

    return api
      .post('/Client/UpdateClientStatus', null, {
        params: {
          client_id: clientId,
          status: status
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - UpdateClientStatus:', error.response?.data || error.message);
        throw error;
      });
  },

  // Get Business Interaction Log
  GetBusinessInteractionLog: (businessId, clientId) => {
    if (!businessId && !clientId) {
      return Promise.reject(new Error("Business ID or Client ID is required"));
    }

    return api
      .get('/Client/GetBusinessInteractionLog', {
        params: {
          business_id: businessId || "",
          client_id: clientId || ""
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetBusinessInteractionLog:', error.response?.data || error.message);
        throw error;
      });
  }
};

export default ClientService;